module.exports = __webpack_public_path__ + "static/img/icon0_sel.c4581f5c.svg";